import React from "react";
import { useContext } from "react";
import Button from "../components/leasing.c.button";
import { ReversePaymentContext } from "../context/leasing.ctx.reversePayment";
import { Transition } from "@headlessui/react";
import classNames from "classnames";
import { useState } from "react";
import { EmitterStatus } from "../../../event";
import API from "../api/api.main";
import { Auth } from "aws-amplify";
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../../utils/getLocalDateTime";

function DrawerReversePayment({
  refetch,
  getEvidence,
  date,
  setDate,
  loan,
  oriLoan,
  env = "sandbox",
  evidences = [],
}) {
  const {
    loadingCal,
    openReverse,
    setOpenReverse,
    currentEvidenceIndex,
    setCurrentEvidenceIndex,
    evidence,
    setEvidence,
  } = useContext(ReversePaymentContext);

  const [loading, setLoading] = useState(false);

  const onClickClose = async () => {
    setOpenReverse(false);
    setCurrentEvidenceIndex(-1);
    setEvidence(null);
  };

  const onClickCancel = async (isSubmit = false, submitDate) => {
    if (loading) return;
    const defaultDate = isSubmit
      ? submitDate
      : sessionStorage.getItem(`${loan?.loan_id}_date`) || date;
    setCurrentEvidenceIndex(-1);
    setEvidence(null);
    await refetch(true, new Date(defaultDate));
    if (getEvidence) {
      await getEvidence();
    }
  };

  const onClickSubmitRecal = async () => {
    try {
      if (loading) return;
      setLoading(true);

      let cloneOriLoan = _.cloneDeep(oriLoan); // ตัวหลัก
      let cloneLoan = _.cloneDeep(loan); // ตัว recal
      let cloneEvidences = _.cloneDeep(evidences);

      let deletePreInstallments = [];

      const evi_paid_date = getCurrentLocalDateTime(
        evidence?.paidDate
      ).fullDate;

      for (const installment of cloneOriLoan.installments) {
        let findLoanInstallment = cloneLoan.installments.find(
          (cloneLoanInstallment) => cloneLoanInstallment.id === installment.id
        );
        const pre_installments = installment.pre_installments;

        if (findLoanInstallment) {
          const length_loan_pre_installments =
            findLoanInstallment.pre_installments.length;
          const length_ori_pre_installments = pre_installments.length;
          let startSlice =
            length_loan_pre_installments === 0
              ? 0
              : length_loan_pre_installments - 1;

          if (
            findLoanInstallment?.disabledPeriod &&
            installment.disabledPeriod &&
            length_loan_pre_installments === length_ori_pre_installments
          ) {
            startSlice = length_ori_pre_installments;
          }

          const preInstallments = pre_installments.slice(
            startSlice,
            length_ori_pre_installments
          );
          deletePreInstallments.push(...preInstallments);
        } else {
          deletePreInstallments.push(...pre_installments);
        }
      }

      const filtetEvidences = cloneEvidences
        .map((evidence, index) => {
          if (index <= currentEvidenceIndex) {
            return {
              loan_id: evidence.loan_id,
              index: evidence.index,
            };
          }
          return null;
        })
        .filter((evidence) => evidence);

      const pathUrl =
        env === "sandbox" ? "loanSandbox/updateRecal" : "/updateRecal";

      let newDeletePreInstallments = deletePreInstallments
        .map((preInstallment) => {
          if (preInstallment?.pre_status !== "PENDING") {
            return {
              installment_id: preInstallment?.installment_id,
              period: preInstallment?.period,
            };
          }
          return null;
        })
        .filter((preInstallment) => preInstallment);

      let newOriInstallments = _.cloneDeep(cloneLoan?.ori_installments).map(
        (installment) => {
          const filterPrevInstallments = newDeletePreInstallments
            .filter((deletePreInstallment) => {
              return deletePreInstallment.installment_id === installment.id;
            })
            .sort((a, b) => a.period - b.period);

          let newLastPeriod = installment.lastPeriod;

          if (filterPrevInstallments.length > 0) {
            newLastPeriod = Number(
              Number(filterPrevInstallments[0].period - 0.01).toFixed(2)
            );
          }

          return {
            ...installment,
            lastPeriod: newLastPeriod,
          };
        }
      );

      for (const newOriInstallment of newOriInstallments) {
        newOriInstallment.pre_installments = [];
      }

      if (cloneLoan?.ori_installments.length > 0) {
        delete cloneLoan?.ori_installments;
      }

      await API.put("MoneyHubAdmin", `/leasing/${pathUrl}`, {
        body: {
          newLeasing: {
            ...cloneLoan,
            installments: newOriInstallments,
          },
          deletePreInstallments: newDeletePreInstallments,
          deleteEvidences: filtetEvidences,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await EmitterStatus("SUCCESS");
      await onClickCancel(true, evi_paid_date);
      setOpenReverse(false);
      setDate(evi_paid_date);
      sessionStorage.setItem(`${loan?.loan_id}_date`, evi_paid_date);
    } catch (error) {
      console.log(error);
      await EmitterStatus("ERROR", { text: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Transition
      show={openReverse}
      enter="transition-opacity duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className=" fixed bottom-0 left-0 bg-white py-5 px-6 z-50 w-full border-t border-blue-300">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <div className="">
              ระบบย้อนเวลาการชำระเงิน (คลิกที่รูปดวงตาตรงหลักฐานการชำระเงิน
              ถ้าดวงตาเป็นสีเขียวจะเริ่ม Recal ตั้งแต่อันนั้นไล่ลงมาเรื่อยๆ)
            </div>
            {evidence !== null ? (
              <div className="text-sm flex space-x-2">
                <div className="font-bold">งวดที่</div>
                <div>{evidence.installment_relate}</div>
              </div>
            ) : (
              <div className="text-red-500 text-sm">
                โปรดเลือกหลักฐานการชำระเงิน
              </div>
            )}
          </div>
          <div className="flex items-center space-x-2">
            {currentEvidenceIndex >= 0 ? (
              <React.Fragment>
                <Button
                  onClick={() => onClickSubmitRecal()}
                  className={classNames("rounded transition-all duration-200", {
                    "cursor-pointer bg-green-500 hover:bg-green-600":
                      evidence && !loadingCal && !loading,
                    "cursor-not-allowed bg-gray-500 ":
                      !evidence || loading || loadingCal,
                  })}
                >
                  {loadingCal
                    ? "กำลังโหลดข้อมูล"
                    : loading
                    ? "กำลังดำเนินการ (ห้ามปิดหน้าจอ)"
                    : "ยืนยัน"}
                </Button>
                <Button
                  onClick={() => onClickCancel()}
                  className={classNames("rounded", {
                    "cursor-pointer bg-red-500 hover:bg-red-600":
                      !loading && !loadingCal,
                    "cursor-not-allowed bg-gray-500": loading || loadingCal,
                  })}
                >
                  ยกเลิก
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Button
                  onClick={() => onClickClose()}
                  className="bg-red-500 rounded"
                >
                  ปิด
                </Button>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default DrawerReversePayment;
